// components/ForgotPassword.jsx

import React, { useState } from "react";
import "./css/login.css";
import { url } from "../../Config";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {

  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  const [form, setForm] = useState({
    email: "",
    otp: "",
    newPassword: "",
    confirmPassword: ""
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    setForm(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };


  /* ---------------- SEND OTP ---------------- */

  const sendOTP = async () => {

    if (!form.email) {
      setError("Please enter your email");
      return;
    }

    try {

      setLoading(true);
      setError("");

      const res = await fetch(`${url}/api/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.email })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Failed to send OTP");
        return;
      }

      setStep(2);

    } catch {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };


  /* ---------------- RESET PASSWORD ---------------- */

  const resetPassword = async () => {

    if (!form.otp || !form.newPassword || !form.confirmPassword) {
      setError("Fill all fields");
      return;
    }

    if (form.newPassword !== form.confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    try {

      setLoading(true);
      setError("");

      const res = await fetch(`${url}/api/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: form.email,
          otp: form.otp,
          newPassword: form.newPassword
        })
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Reset failed");
        return;
      }

      alert("Password reset successful!");
      navigate("/login");

    } catch {
      setError("Network error");
    } finally {
      setLoading(false);
    }
  };


  return (

    <div className="login-container">

      <div className="login-card">

        <h2 className="login-title">Forgot Password</h2>

        <p className="login-subtitle">
          {step === 1
            ? "Enter your email to receive OTP"
            : "Enter OTP and new password"}
        </p>


        {error && <div className="auth-error">{error}</div>}


        {/* STEP 1 */}
        {step === 1 && (

          <>
            <div className="input-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter your email"
                value={form.email}
                onChange={handleChange}
              />
            </div>

            <button
              className={`login-btn ${loading ? "loading" : ""}`}
              onClick={sendOTP}
              disabled={loading}
            >
              {loading ? "Sending OTP..." : "Send OTP"}
            </button>
          </>
        )}


        {/* STEP 2 */}

        {step === 2 && (

          <>

            <div className="input-group">
              <label>OTP</label>
              <input
                type="text"
                name="otp"
                placeholder="Enter OTP"
                value={form.otp}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>New Password</label>
              <input
                type="password"
                name="newPassword"
                placeholder="Enter new password"
                value={form.newPassword}
                onChange={handleChange}
              />
            </div>

            <div className="input-group">
              <label>Confirm Password</label>
              <input
                type="password"
                name="confirmPassword"
                placeholder="Confirm password"
                value={form.confirmPassword}
                onChange={handleChange}
              />
            </div>

            <button
              className={`login-btn ${loading ? "loading" : ""}`}
              onClick={resetPassword}
              disabled={loading}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </button>

          </>
        )}

      </div>

    </div>
  );
};

export default ForgotPassword;